import React, {useEffect, useRef, useState} from "react";
import css from './block1Card2.module.scss'
import {observer, useLocalObservable} from "mobx-react";
import classNames from "classnames";
import {makeAutoObservable} from "mobx";
import * as Api from "api/api";
import {allGoodsImg} from "api/api";
import Swiper from "swiper";
import GoodsType, {goodsTypeEnumMap} from "enum/GoodsType";
import MyRouter from "router/router";
import NewsMenuType from "enum/NewsMenuType";
import {useHistory} from "react-router-dom";
import MyRouterUtil from "../../utils/MyRouterUtil";
import {DateTime} from "luxon";

import imgAdDeepSeek from './img/deepseek广告.png'
import imgAdDeepSeekArrowDown from './img/deepSeek广告箭头下.png'
import imgBlock1Menu from './img/block1功能板块.png'

class SecKillStore {

    list = []

    startTime = undefined
    endTime = undefined
    hourNumber = 0
    minuteNumber = 0
    secondNumber = 0

    get secKillTimeStr() {
        return this.startTime?.toFormat('HH:mm')
    }

    setStartTime(value) {
        this.startTime = value
    }

    setHourNumber(value) {
        this.hourNumber = value
    }

    get hourNumberStr() {
        return `${this.hourNumber}`.padStart(2, '0')
    }

    setMinuteNumber(value) {
        this.minuteNumber = value
    }

    get minuteNumberStr() {
        return `${this.minuteNumber}`.padStart(2, '0')
    }

    setSecondNumber(value) {
        this.secondNumber = value
    }

    get secondNumberStr() {
        return `${this.secondNumber}`.padStart(2, '0')
    }

    setList(value) {
        this.list = value
    }


    datetimeList = [
        0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22
    ].map(hour =>
        DateTime.now().set({
            hour: hour
        }).startOf('hour')
    )

    use(datetimeList) {
        const curTime = DateTime.now();
        const curHour = curTime.hour

        const i = Math.floor(curHour / 2)
        const secKillStartTime = datetimeList[i]

        let secKillEndTime = secKillStartTime.plus({hours: 2})

        const diffObj = secKillEndTime.diff(curTime, ['seconds', 'minutes', 'hours']).toObject()
        const secondNumber = Math.floor(diffObj.seconds)
        const minuteNumber = diffObj.minutes
        const hourNumber = diffObj.hours


        this.startTime = secKillStartTime
        this.endTime = secKillEndTime
        this.hourNumber = hourNumber
        this.minuteNumber = minuteNumber
        this.secondNumber = secondNumber
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const secKillStore = new SecKillStore()

function useFetchSecKillList({setSecKillList}) {
    useEffect(() => {
        Api.secKillList({
            page: 1,
            size: 12
        }).then((list) => {
            setSecKillList(list)
        });
    }, [])
}

function useSecKill() {
    useEffect(() => {
        const timer = setInterval(() => secKillStore.use(secKillStore.datetimeList), 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);
}


const Index = ({className, aiConfig}) => {
    const history = useHistory()

    useFetchSecKillList({setSecKillList: v => secKillStore.setList(v)})

    const swiperRef = useRef()
    useEffect(() => {
        if (!(swiperRef.current && secKillStore.list.length)) {
            return;
        }

        let slidesPerView = aiConfig.open ? 1 : 3;

        const mySwiper = new Swiper(swiperRef.current, {
            slidesPerView: slidesPerView,
            spaceBetween: 15,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        })


        //鼠标覆盖停止自动切换
        swiperRef.current.onmouseover = function () {
            mySwiper.autoplay.stop();
        }

        //鼠标离开开始自动切换
        swiperRef.current.onmouseout = function () {
            mySwiper.autoplay.start();
        }

    }, [swiperRef.current, secKillStore.list.length]);

    useSecKill()

    // 商品详情页
    const toGoodsInfo = ({goodsType, id}) => {
        const startTime = secKillStore.startTime.valueOf()
        const endTime = secKillStore.endTime.valueOf()

        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id, startTime, endTime})
    }

    //  所有商品页面
    const toAllGoods = () => {
        console.log(`to all goods`)
        MyRouterUtil.build({history}).toSearchPage({})
    }

    const toNews = () => {
        history.push({
            pathname: `${MyRouter.News.realPath}`,
            search: `menuType=${NewsMenuType.NEWS}`,
        })
    }

    const onClickAi1 = () => {
        //todo ai
        console.log('onClickAi1')
    }
    const onClickAi2 = () => {
        //todo ai
        console.log('onClickAi2')
    }
    const onClickAi3 = () => {
        //todo ai
        console.log('onClickAi3')
    }
    const onClickAi4 = () => {
        //todo ai
        console.log('onClickAi4')
    }


    return (
        <div
            className={
                classNames(className, 'block1-card2 mt-[16px]', {['flex w-[1228px]']: aiConfig.open})
            }
        >
            <div className='block1-card2-left z-1'>
                {/*秒杀*/}
                <div
                    className={classNames(css.secKill, aiConfig.open ? 'bg-[#E6E6F0]/60' : 'bg-[#E6E6F0]', {['w-[979px]']: aiConfig.open})}>
                    <div
                        className={
                            classNames(css.secKillContainer, {
                                [css.w360]: aiConfig.open,
                                [css.w647]: !aiConfig.open,
                            })
                        }
                    >
                        {/*秒杀信息*/}
                        <div className={css.left}>
                            <div className={css.title}>
                                企业秒杀
                            </div>
                            <div className={css.floor2}>
                                <span>{secKillStore.secKillTimeStr}</span>点场，距结束
                            </div>
                            <div className={css.timeFloor}>
                                <div className={css.item}>
                                    {secKillStore.hourNumberStr}
                                </div>
                                <div className={css.item}>
                                    {secKillStore.minuteNumberStr}
                                </div>
                                <div className={css.item}>
                                    {secKillStore.secondNumberStr}
                                </div>
                            </div>
                        </div>
                        {/*秒杀轮播*/}
                        <div className={css.right}>
                            <div ref={swiperRef} className={classNames('swiper', css.swiper)}>
                                <div className={classNames('swiper-wrapper', css.swiperWrapper)}>
                                    {
                                        secKillStore.list.map((item, i) => {
                                            const {
                                                selfGoodsId,
                                                jdItemId,
                                                pddGoodsSign,
                                                name,
                                                price,
                                                secKillPrice,
                                                mainPic,
                                                goodsType
                                            } = item

                                            const goodsTypeText = goodsTypeEnumMap.get(goodsType);
                                            let id;
                                            switch (goodsType) {
                                                case GoodsType.PDD:
                                                    id = pddGoodsSign;
                                                    break;
                                                case GoodsType.JD:
                                                    id = jdItemId;
                                                    break;
                                                case GoodsType.SELF:
                                                default:
                                                    id = selfGoodsId;
                                                    break;
                                            }
                                            return (
                                                <div
                                                    key={i}
                                                    className={classNames('swiper-slide', css.swiperSlide)}
                                                    onClick={() => {
                                                        toGoodsInfo({goodsType, id})
                                                    }}
                                                >
                                                    <img className={css.img} src={mainPic} alt=''/>
                                                    <div className={css.goodsTypeWrapper}>
                                                        <span>{goodsTypeText}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    {/*全部商品*/}
                    <div className={classNames(css.allGoodsContainer, aiConfig.open ? 'ml-[19px]' : 'ml-[9px]')}>
                        <div className={css.left}>
                            <div className={css.title}>
                                全部商品
                            </div>
                            <div className={css.subTitle}>
                                海量商品尽享低价购入
                            </div>
                            <button className={css.btn} onClick={toAllGoods}>
                                <div className={css.text}>
                                    查看
                                </div>
                                <img src={require('./img/block1秒杀楼层全部商品箭头右.png')} alt=""
                                     className={css.icon}/>
                            </button>
                        </div>
                        <div className={css.right}>
                            <img src={allGoodsImg} alt=""/>
                        </div>
                    </div>

                    {/*咨询中心*/}
                    <div className={css.newsContainer}>
                        <img src={require('./img/block1资讯中心背景.png')} className={css.bgImg}/>
                        <div className={css.left}>
                            <div className={css.title}>资讯中心</div>
                            <div className={css.subTitle}>掌握资讯 快人一步</div>
                            <button className={css.btn} onClick={toNews}>
                                <div className={css.text}>
                                    查看
                                </div>
                                <img src={require('./img/block1秒杀楼层资讯中心箭头右.png')} alt=""
                                     className={css.icon}/>
                            </button>
                        </div>
                    </div>
                </div>
                {/*deepSeek广告*/}

                {
                    aiConfig.open &&
                    <div className='w-[963px] h-[157px] mt-[35px] ml-[28px] relative z-0'
                         style={{backgroundImage: `url(${imgAdDeepSeek})`}}>
                        <img src={imgAdDeepSeekArrowDown}
                             className="block w-[52px] h-[53px] absolute z-10 right-[-25px] bottom-[-28px] hover:cursor-pointer"
                             alt=""/>
                    </div>
                }
            </div>
            {
                aiConfig.open &&
                <div
                    className='block1-card2-right ai-menu w-[235px] h-[389px] ml-auto relative pt-[31px] z-0'
                >
                    <img src={imgBlock1Menu} className='block absolute inset-[3px] z-[-1]'/>
                    <button className='w-[210px] h-[69px] z-1 block ml-auto! mr-auto!' onClick={onClickAi1}/>
                    <button className='w-[210px] h-[69px] z-1 block ml-auto! mr-auto! mt-[17px]!' onClick={onClickAi2}/>
                    <button className='w-[210px] h-[69px] z-1 block ml-auto! mr-auto! mt-[17px]!' onClick={onClickAi3}/>
                    <button className='w-[210px] h-[69px] z-1 block ml-auto! mr-auto! mt-[17px]!' onClick={onClickAi4}/>
                </div>
            }
        </div>
    )
}

export default observer(Index)